import { UtilityEngineeringPage } from "@/pages/utility/engineering/UtilityEngineeringPage";
import { GasEntryPage } from "@/pages/utility/entry/GasEntryPage";
import { UtilityManagementPage } from "@/pages/utility/management/UtilityManagementPage";
import { ConsumptionPage } from "@/pages/utility/report/ConsumptionPage";

export const routeUtilityEngineering = "/utility/engineering";
export const utilityEngineeringPermission =
	"ui.navbar.mill.utility.engineering";
export const routeUtilityManagement = "/utility/management";
export const utilityManagementPermission = "ui.navbar.mill.utility.management";
export const routeGasEntry = "/utility/gas-entry";
export const gasEntryPermission = "ui.navbar.mill.gas.entry";
export const utilityNavbarPermission = "ui.navbar.utilities";
export const routeUtilityConsumption = "/utility/consumption";
export const utilityConsumptionPermission = "ui.navbar.mill.consumption";

export const utilityConsumptionRoute = {
	path: routeUtilityConsumption,
	element: <ConsumptionPage />,
	permission: utilityConsumptionPermission,
};

export const utilityEngineeringRoute = {
	path: routeUtilityEngineering,
	element: <UtilityEngineeringPage />,
	permission: utilityEngineeringPermission,
};

export const utilityManagementRoute = {
	path: routeUtilityManagement,
	element: <UtilityManagementPage />,
	permission: utilityManagementPermission,
};

export const gasEntryRoute = {
	path: routeGasEntry,
	element: <GasEntryPage />,
	permission: gasEntryPermission,
};

export const utilityRoutes = [
	utilityConsumptionRoute,
	utilityEngineeringRoute,
	utilityManagementRoute,
	gasEntryRoute,
];
